import React from 'react';
import { FilePlus, FolderOpen } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

type WorkflowChoiceDialogProps = {
  open: boolean;
  onNewScript: () => void;
  onExistingScript: () => void;
  onCancel: () => void;
};

const WorkflowChoiceDialog: React.FC<WorkflowChoiceDialogProps> = ({
  open,
  onNewScript,
  onExistingScript,
  onCancel,
}) => {
  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="bg-[#141414] border-[#2a2a2a] text-white sm:max-w-lg [&>button]:hidden">
        <DialogHeader>
          <DialogTitle className="text-2xl font-sans font-bold text-white">
            Script Workflow
          </DialogTitle>
          <DialogDescription className="text-white/60 font-serif italic mt-2">
            Choose how you would like to begin. Review a new script or continue work on one you
            have already uploaded.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-3 mt-4">
          <Button
            onClick={onNewScript}
            className="h-auto py-4 px-4 flex items-start gap-3 bg-gold-button text-neutral-700 hover:bg-gold-button-dark font-sans justify-start"
          >
            <FilePlus className="h-5 w-5 shrink-0 mt-0.5" />
            <span className="text-left">
              <span className="block font-semibold">Review a new script</span>
              <span className="block text-sm opacity-80 font-normal mt-0.5">
                Start fresh with upload, analyse, and scorecard steps.
              </span>
            </span>
          </Button>
          <Button
            variant="outline"
            onClick={onExistingScript}
            className="h-auto py-4 px-4 flex items-start gap-3 border-[#2a2a2a] bg-black text-white hover:bg-[#1a1a1a] font-sans justify-start"
          >
            <FolderOpen className="h-5 w-5 shrink-0 mt-0.5" />
            <span className="text-left">
              <span className="block font-semibold">Work on an existing script</span>
              <span className="block text-sm text-white/60 font-normal mt-0.5">
                Resume where you left off on a previous upload or analysis.
              </span>
            </span>
          </Button>
        </div>
        <DialogFooter className="mt-2">
          <Button
            variant="outline"
            onClick={onCancel}
            className="border-[#2a2a2a] text-white hover:bg-[#1a1a1a] font-sans w-full sm:w-auto"
          >
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default WorkflowChoiceDialog;
